export const DEFAULT_IMG = require("assets/images/default/default_img.jpg");
